export const formatDateWithTimezone = (date = new Date()) => {
  const pad = (n: number) => String(n).padStart(2, '0')

  const [y, m, d, h, min, s] = [
    date.getFullYear(),
    date.getMonth() + 1,
    date.getDate(),
    date.getHours(),
    date.getMinutes(),
    date.getSeconds(),
  ].map(pad)

  const offset = -date.getTimezoneOffset()
  const sign = offset >= 0 ? '+' : '-'
  const [oh, om] = [
    Math.floor(Math.abs(offset) / 60),
    Math.abs(offset) % 60,
  ].map(pad)

  return `${y}-${m}-${d} ${h}:${min}:${s} ${sign}${oh}:${om}`
}
